import {
    Box 
} from '@mui/material';
import {
    useRouter 
} from 'next/router';
import {
    useContext, useEffect 
} from 'react';
import Loading from '../../components/core/loading';
import SessionContext from '../../contexts/session';
import {
    FlowType 
} from '../../components/start/flow-type.enum';
import withAuthentication from '../../components/authentication/withauthentication';
import {
    NOT_LOADED_HINT 
} from '../_app';
import {
    ccTrialTrack 
} from '../../lib/utils';
import {
    useCookies 
} from 'react-cookie';
import {
    Data, get 
} from '../../networking';
import {
    isDryJan 
} from '../../logic/dryJan';

/**
 * NOTE: currently this page assumes that user is coming from initial checkout so it fires the
 * cc trial events
 */
export const getCheckoutConfirmPageUrl = (options?: {
    /* Redirect to page after checkout-success page processes and loads */
    redirect?: string,
    /* Replaces default confirm url (checkout-success) | Must start with '/' */
    url?: string;
}): string => {
    const {
        redirect, url 
    } = options ?? {};
    if (url && !url.startsWith('/')) {
        throw new Error('Url option must start with \'/\'');
    }
    if (url) return url;
    return redirect
        ? `/checkout-success?redirect=${encodeURIComponent(redirect)}&session_id={CHECKOUT_SESSION_ID}`
        : '/checkout-success?session_id={CHECKOUT_SESSION_ID}';
};

const getCheckoutSession = async (id: string): Promise<Data> => {
    return await get('payments-gateway/stripe/checkout-session', {
        id 
    });
};

function CheckoutSuccess(): JSX.Element {
    const router = useRouter();
    const {
        session_id,
        redirect
    } = router.query;
    const [cookies] = useCookies();
    const {
        user 
    } = useContext(SessionContext);

    const handleCheckoutSession = async () => {
        return await getCheckoutSession(session_id as string);
    };

    /**
     * 
     * @param res is `userPaymentEntity`
     */
    const handleRedirect = (res?: any) => {
        if (res?.subscriptionStatus === 'trialing') {
            ccTrialTrack(user, cookies, router.asPath);
        }

        if ([
            'ss_DryishJanuary2025',
            'ss_SoberishMom',
            'ss_UCBDryishJanuary2025',
            'ss_ABC-Fitness-DryishJanuary2025',
            'ss_SoberishMom-DryishJanuary2025',
            'ss_Zumba'
        ].includes(user.formId)) {
            return router.push(`/challenge/invite?userType=new_user&showContinue&redirect=${redirect as string ?? '/premium-coaching/intro'}`);
        }

        if (isDryJan()) {
            const userChallenge = user.__challenges__?.find(c => c.status === 'active')
                ?? user.__challenges__?.find(c => c.status === 'pending');

            if (!userChallenge) {
                return router.push(`/challenge/opt-in/dryish-january-2025?fromCheckout&redirect=${redirect as string ?? '/premium-coaching/intro'}`);
            }
        }

        if ((user.formId.startsWith('ss_') && !redirect) || (!user.formId.startsWith('ss_') && user.flowType !== FlowType.PREMIUM)) {
            return router.push('/premium-coaching/intro');
        }

        router.push(redirect as string ?? '/share');
    };

    useEffect(() => {
        if (user.email !== NOT_LOADED_HINT && cookies) {
            if (session_id) {
                handleCheckoutSession().then((res) => handleRedirect(res));
            } else {
                handleRedirect();
            }
        }
    }, [user, cookies]);

    return (
        <Box>
            <Loading />
        </Box>
    );
}

export default withAuthentication(CheckoutSuccess);
